import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Basket } from '../basket.service';
import { FormControl, FormGroup } from '@angular/forms';
import { OrderService } from '../order.service';
export interface DialogData {
  name: string;
  password: string;
}
@Component({
  selector: 'app-order-page',
  templateUrl: './order-page.component.html',
  styleUrls: ['./order-page.component.css']
})
export class OrderPageComponent implements OnInit {
  @Output() data: EventEmitter<Basket[]> = new EventEmitter<Basket[]>();
  @Output() total: EventEmitter<number> = new EventEmitter<number>();
  @Output() orderID: EventEmitter<number> = new EventEmitter<number>();
  @Input() dataSource: any = [];
  basket: Basket[] = [];
  pipe = new DatePipe('en-US');
  constructor(private orderService: OrderService, public dialog: MatDialog,) { }

  ngOnInit(): void {
    let now = Date.now();
    let date = this.pipe.transform(now, 'y-MM-dd') || '';
    this.orderService.GetFilter(date).subscribe((data) => {
      this.dataSource = data;
    });
    this.orderDateForm.patchValue({
      date: date
    })

  }
  orderDateForm = new FormGroup({
    date: new FormControl(''),
  })

  getOrderByDate() {
    const dataForm = this.orderDateForm.value;
    this.orderService.GetFilter(dataForm.date).subscribe((data) => {
      this.dataSource = data;
    });
  }

  deleteOrderByID(orderID: number) {
    this.orderService.deleteOrder(orderID).subscribe(() => {
      this.orderService.GetAll().subscribe((data) => {
        this.dataSource = data;
      });
    });
  }
  openDialog(customer_name: string, orderID: number): void {
    const dialogRef = this.dialog.open(DeleteDialog, {
      width: '250px',
      data: { name: customer_name,password:'8842' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined && result == "delete") {
        this.deleteOrderByID(orderID);
      }
    });
  }

  selectOrder(orderID: number) {
    var basket: Basket;
    var temp: Basket[] = [];
    this.orderService.GetByID(orderID).subscribe((data) => {
      for (let o of data.order) {
        basket = {
          id: o.id,
          product_id: o.product_id,
          barcode: o.barcode,
          name: o.name,
          unit_type: o.unit_type,
          wholesale_price: o.price,
          wholesale_amount: (o.price * o.qty),
          quantity: o.qty,
          image: o.image,
          front_store_amount: 0,
          front_store_price: 0,
        };
        temp.push(basket);
      }
      this.basket = [...temp];
      this.data.emit(this.basket);
      this.total.emit(data.total_price);
      this.orderID.emit(data.order_id);
      temp = [];
    });
  }
  displayedColumns: string[] = ['bill_name', 'created', 'total_price', 'option'];
}

@Component({
  selector: 'delete-dialog',
  templateUrl: 'delete-dialog.html',
})
export class DeleteDialog {

  constructor(
    public dialogRef: MatDialogRef<DeleteDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }
    passwordControl = new FormControl('');
}